import { c as _c } from "react/compiler-runtime";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
import type { NFTLite } from "@/components/user/settings/UserSettingsImgSelectMeme";
import CommonCardSkeleton from "@/components/utils/animation/CommonCardSkeleton";
import CommonTablePagination from "@/components/utils/table/paginator/CommonTablePagination";
import type { NextGenCollection } from "@/entities/INextgen";
import type { Transaction } from "@/entities/ITransaction";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserPageStatsActivityWalletFilter from "../filter/UserPageStatsActivityWalletFilter";
import { UserPageStatsActivityWalletFilterType } from "../UserPageStatsActivityWallet";
import UserPageStatsActivityWalletTable from "./UserPageStatsActivityWalletTable";
export default function UserPageStatsActivityWalletTableWrapper(t0) {
  const $ = _c(24);
  const {
    filter,
    profile,
    transactions,
    memes,
    memeLab,
    nextgenCollections,
    totalPages,
    page,
    isFirstLoading,
    loading,
    setPage,
    onActiveFilter
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [UserPageStatsActivityWalletFilterType.ALL]: "No transactions",
      [UserPageStatsActivityWalletFilterType.AIRDROPS]: "No airdrops",
      [UserPageStatsActivityWalletFilterType.MINTS]: "No mints",
      [UserPageStatsActivityWalletFilterType.SALES]: "No sales",
      [UserPageStatsActivityWalletFilterType.PURCHASES]: "No purchases",
      [UserPageStatsActivityWalletFilterType.TRANSFERS]: "No transfers",
      [UserPageStatsActivityWalletFilterType.BURNS]: "No burns"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const FILTER_TO_NO_DATA = t1;
  if (isFirstLoading) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="tw-mt-2 sm:tw-mt-4 tw-w-full tw-h-96"><CommonCardSkeleton /></div>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== filter || $[3] !== onActiveFilter) {
    t2 = <UserPageStatsActivityWalletFilter activeFilter={filter} setActiveFilter={onActiveFilter} />;
    $[2] = filter;
    $[3] = onActiveFilter;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== loading) {
    t3 = loading && <CircleLoader />;
    $[5] = loading;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="tw-w-full tw-inline-flex tw-justify-between tw-space-x-4 tw-items-center tw-px-4 sm:tw-px-6 tw-mt-6">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== filter || $[11] !== loading || $[12] !== memeLab || $[13] !== memes || $[14] !== nextgenCollections || $[15] !== page || $[16] !== profile || $[17] !== setPage || $[18] !== totalPages || $[19] !== transactions) {
    t5 = <div>{transactions.length ? <div className="tw-flow-root tw-scroll-py-3 tw-overflow-auto"><UserPageStatsActivityWalletTable transactions={transactions} profile={profile} memes={memes} memeLab={memeLab} nextgenCollections={nextgenCollections} />{totalPages > 1 && <CommonTablePagination currentPage={page} setCurrentPage={setPage} totalPages={totalPages} haveNextPage={page < totalPages} small={true} loading={loading} />}</div> : <div className="tw-py-4 tw-px-4 sm:tw-px-6 tw-text-sm sm:tw-text-base tw-italic tw-text-iron-500">{FILTER_TO_NO_DATA[filter]}</div>}</div>;
    $[10] = filter;
    $[11] = loading;
    $[12] = memeLab;
    $[13] = memes;
    $[14] = nextgenCollections;
    $[15] = page;
    $[16] = profile;
    $[17] = setPage;
    $[18] = totalPages;
    $[19] = transactions;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== t4 || $[22] !== t5) {
    t6 = <div className="tw-mt-2 lg:tw-mt-4 tw-bg-iron-950 tw-border tw-border-iron-800 tw-border-solid tw-rounded-xl">{t4}{t5}</div>;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
}